export default {
    'meltwater': `${process.env.assetsPath}icons/meltwater-icons/meltwater-svg-sprite.svg`,
    'mediatypes': `${process.env.assetsPath}icons/meltwater-icons/meltwater-mediatypes-svg-sprite.svg`,
    'action': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-action.svg`,
    'alert': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-alert.svg`,
    'av': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-av.svg`,
    'communication': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-communication.svg`,
    'content': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-content.svg`,
    'device': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-device.svg`,
    'editor': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-editor.svg`,
    'file': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-file.svg`,
    'hardware': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-hardware.svg`,
    'image': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-image.svg`,
    'maps': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-maps.svg`,
    'navigation': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-navigation.svg`,
    'notification': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-notification.svg`,
    'places': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-places.svg`,
    'social': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-social.svg`,
    'toggle': `${process.env.assetsPath}icons/material-design-icons/svg-sprite-toggle.svg`
}



// WEBPACK FOOTER //
// ./src/lib/assets/mw-icons.ts